import { render, staticRenderFns } from "./cnzz.vue?vue&type=template&id=def478e4&scoped=true&"
import script from "./cnzz.vue?vue&type=script&lang=js&"
export * from "./cnzz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def478e4",
  null
  
)

export default component.exports